import FactorDeleteActivity from "./FactorDeleteActivity";
import FactorDeleteActivityPopup from "./FactorDeleteActivityPopup";

export default FactorDeleteActivity;

export { FactorDeleteActivityPopup };
